import { DashboardLayout } from '@/components/layout/DashboardLayout';
import ValuationAdvisorComponent from '@/components/ledger/ValuationAdvisor';
import { useTenantStore } from '@/hooks/useTenantStore';
import { useSearchParams } from 'react-router-dom';

const ValuationAdvisor = () => {
  const { tenantId } = useTenantStore();
  const [searchParams] = useSearchParams();
  const roundId = searchParams.get('roundId') || undefined;

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Valuation Advisor</h1>
          <p className="text-muted-foreground">
            Multi-method valuation models and negotiation intelligence for founders
          </p>
        </div>

        {tenantId ? (
          <ValuationAdvisorComponent companyId={tenantId} roundId={roundId} />
        ) : (
          <div className="text-center text-muted-foreground py-8">
            Please select a company to access valuation tools
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ValuationAdvisor;
